import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 18 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 18 19\" id=\"icon-close\">\n    <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 8.72L17.275 0 18 .688l-8.294 8.74 8.276 7.848-.688.725L9 10.136.707 18.001l-.688-.725 8.275-7.848L0 .688.725 0 9 8.72z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol